module.exports = __webpack_public_path__ + "static/img/function.90c6df9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/automation/function.svg
// module id = G7qp
// module chunks = 46